import React from "react";
import PolicyEmbed from "./PolicyEmbed";

export default function TermsConditionsPage() {

  return <PolicyEmbed title="Terms & Conditions"
                      src="https://app.termly.io/policy-viewer/policy.html?policyUUID=49a2227f-4c5b-4208-abc4-9fd48bc87c80"
                      height={12500} />

}
